<template>
    <section id="sec1">

    <div class="banner">

        <div class="slider">
            <div 
                class="slides"
                @mousedown="iniciarArrasto"
                @mousemove="moverArrasto"
                @mouseup="finalizarArrasto"
                @mouseleave="cancelarArrasto"
                @touchstart="iniciarArrasto"
                @touchmove="moverArrasto"
                @touchend="finalizarArrasto"
            >
                    <input v-for="slide in slides" :key="slide.ids" type="radio" name="radio-btn" :id="'radio'+slide.ids">

                    <div v-for="slide in slides" :key="slide.ids" :class="{'slide first': slide.ids == 1, 'slide': slide.ids != 1}">
                        <img :src="slide.fotos" :alt="slide.titulo" draggable="false">
                    </div>                     

                <div class="navigation-auto">
                    <div v-for="slide in slides" :key="slide.ids" :class="'auto-btn'+slide.ids"></div>
                </div>                    

            </div>

            <div class="navigation-manual" >
                <label 
                    v-for="slide in slides" 
                    :key="slide.ids" 
                    :for="'radio'+slide.ids" 
                    class="manual-btn"
                    @click="slideAtual = slide.ids"
                ></label>
            </div>

        </div>
        
    </div>

    </section>
</template>

<script>
    export default { 
    name: 'Slides',

    props: {
        cor: true,
        traduzir: true,
    },

    data(){
        return{
            slides: [],
            ids: 0,
            slideAtual: 1,
            meuInterval: null,
            currentRoute: window.location.pathname,

            // controle do arrasto
            arrastando: false,
            posicaoInicialX: 0,
            limiteArrasto: 50 // px mínimos pra considerar como troca de slide
        }
    },

    created(){
        this.pegaSlides();
        this.slideAutomatico();
        this.slideAtual = 1;        
    },

    unmounted(){
        // garante que o interval seja limpo assim que o componente sair da tela
        clearInterval(this.meuInterval);
    },

    methods: {
        async pegaSlides(){
                this.slides = [
                    {fotos: '/imagens/slidedashboard.png', titulo: 'Dashboard', ids: 1},
                    {fotos: '/imagens/slideprodutos.png', titulo: 'Produtos', ids: 2},
                    {fotos: '/imagens/slideredessociais.png', titulo: 'Redessociais', ids: 3}
                ];
        },

        async slideAutomatico(){
            clearInterval(this.meuInterval); // evita criar intervals duplicados

            this.meuInterval = setInterval(() => {
                this.proximoSlide();
            }, 7000);
        },

        proximoSlide(){
            this.slideAtual++;

            if(this.slideAtual > this.slides.length){
                this.slideAtual = 1;
            }
            
            const radio = document.getElementById('radio' + this.slideAtual);

            if(radio){
                radio.checked = true;
            } else {
                // elemento não existe mais (ex: componente sendo desmontado) -> para o interval
                clearInterval(this.meuInterval);
            }
        },

        slideAnterior(){
            this.slideAtual--;

            if(this.slideAtual < 1){
                this.slideAtual = this.slides.length;
            }

            const radio = document.getElementById('radio' + this.slideAtual);

            if(radio){
                radio.checked = true;
            } else {
                // elemento não existe mais (ex: componente sendo desmontado) -> para o interval
                clearInterval(this.meuInterval);
            }
        },

        pegaPosicaoX(e, isFinal = false){
            if(e.type.startsWith('touch')){
                const touch = isFinal ? e.changedTouches[0] : e.touches[0];
                return touch.clientX;
            }
            return e.clientX;
        },

        iniciarArrasto(e){
            this.arrastando = true;
            this.posicaoInicialX = this.pegaPosicaoX(e);
            clearInterval(this.meuInterval); // pausa o auto-play enquanto arrasta
        },

        moverArrasto(e){
            if(!this.arrastando) return;
            // aqui dá pra adicionar um efeito visual de arrasto se quiser futuramente
        },

        finalizarArrasto(e){
            if(!this.arrastando) return;
            this.arrastando = false;

            const posicaoFinalX = this.pegaPosicaoX(e, true);
            const diferenca = this.posicaoInicialX - posicaoFinalX;

            if(diferenca > this.limiteArrasto){
                this.proximoSlide(); // arrastou pra esquerda -> próximo slide
            } else if(diferenca < -this.limiteArrasto){
                this.slideAnterior(); // arrastou pra direita -> slide anterior
            }

            this.slideAutomatico(); // reinicia o auto-play
        },

        cancelarArrasto(){
            if(this.arrastando){
                this.arrastando = false;
                this.slideAutomatico();
            }
        }

    }
}
</script>

<style src="./slides.scss" lang="scss" scoped></style>